import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";

function SelectBox({ title, options, onChange }) {
  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
    onChange(event.target.value);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{title}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={age}
          label="Age"
          onChange={handleChange}
        >
          {options.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default function TaskListAddDialog({ clients = [], onAdd }) {
  const [open, setOpen] = React.useState(false);

  // state client
  const [client, setClient] = React.useState("");

  // state for description
  const [description, setDescription] = React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSaveList = () => {
    // geet the cient Id

    let clientNames = clients.map((client) => client.name);
    // find the index of the client
    let clientIndex = clientNames.indexOf(client);

    // get the client object
    let clientObject = clients[clientIndex];
    let task = {
      clientId: clientObject.storageDocumentId,
      clientName: clientObject.name,
      description: description,
      complete: false,
      timeDateCreated: new Date(),
    };

    onAdd(task);
    handleClose();
  };

  let clientOptions = clients.map((client) => client.name);
  // sort
  clientOptions.sort();

  return (
    <div>
      <Button variant="contained" onClick={handleClickOpen}>
        Add Task
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add Task</DialogTitle>
        <DialogContent>
          <DialogContentText>Add a task by filling in below</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="description"
            label="Description"
            type="text"
            fullWidth
            onChange={(e) => setDescription(e.target.value)}
          />
          <SelectBox
            title="Client"
            options={clientOptions}
            onChange={setClient}
          />
          {/* {client && (
            <SelectBox
              title="Site"
              options={sitesFiltered.map((site) => site.name)}
              onChange={setSite}
            />
          )} */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={!client || !description} onClick={handleSaveList}>
            Add Task
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
